import moment from 'moment'

export function convertMsToHMS(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    // 👇️ if seconds are greater than 30, round minutes up (optional)
    // minutes = seconds >= 30 ? minutes + 1 : minutes;

    minutes = minutes % 60;

    // 👇️ If you don't want to roll hours over, e.g. 24 to 00
    // 👇️ comment (or remove) the line below
    // commenting next line gets you `24:00:00` instead of `00:00:00`
    // or `36:15:31` instead of `12:15:31`, etc.
    hours = hours % 24;
    // console.log(hours, ':', minutes);
    let hours_text = hours == 0 ? '' : padTo2Digits(hours) + ':';
    return hours_text + padTo2Digits(minutes) + ":" + padTo2Digits(seconds);
}
export function convertMsToHMSText(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    // 👇️ if seconds are greater than 30, round minutes up (optional)
    minutes = seconds >= 30 ? minutes + 1 : minutes;

    minutes = minutes % 60;

    // 👇️ If you don't want to roll hours over, e.g. 24 to 00
    // 👇️ comment (or remove) the line below
    // commenting next line gets you `24:00:00` instead of `00:00:00`
    // or `36:15:31` instead of `12:15:31`, etc.
    hours = hours % 24;
    // console.log(hours, ':', minutes);
    let hours_text = hours == 0 ? '' : padTo2Digits(hours) + ' hr ';
    return hours_text + padTo2Digits(minutes) + " min " + padTo2Digits(seconds) + " sec";
}
export function convertSecToHMSText(duration_seconds) {
    console.log()
    let duration = new Date(duration_seconds * 1000).toISOString().substr(11, 8)
    let duration_substr = duration.split(':')
    let hours = duration_substr[0],
        minutes = duration_substr[1],
        seconds = duration_substr[2]
    console.log(hours, minutes, seconds);
    console.log(padTo2Digits(hours), padTo2Digits(minutes), padTo2Digits(seconds));
    let hours_text = hours == 0 ? '' : padTo2Digits(hours) + ' hours ';
    let sec_text = hours != 0 ? '' : padTo2Digits(seconds) + " seconds";
    return hours_text + padTo2Digits(minutes) + " minutes "
        + sec_text;
}

export function getDiffInTextFromMS(milliseconds) {
    console.log("getDiffInTextFromMS", milliseconds)
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    // 👇️ if seconds are greater than 30, round minutes up (optional)
    minutes = seconds >= 30 ? minutes + 1 : minutes;

    minutes = minutes % 60;

    // 👇️ If you don't want to roll hours over, e.g. 24 to 00
    // 👇️ comment (or remove) the line below
    // commenting next line gets you `24:00:00` instead of `00:00:00`
    // or `36:15:31` instead of `12:15:31`, etc.
    hours = hours % 24;
    console.log(hours, ':', minutes, seconds);
    if(hours>0){ 
        return (hours) + ' hours ' + (minutes) + ' minutes'
    }else if(minutes > 0){
        return  (minutes) + ' minutes'
    }
    else{
        return (seconds) + " seconds"
    }
    // return hours_text + padTo2Digits(minutes) + " min " + padTo2Digits(seconds) + " sec";
}
function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}


export function getImgUrl(imgname) {
    return require("@/assets/images/" + imgname);
}

export function formatBytes(bytes, decimals = 0) {
    console.log("in formatbutes", bytes)
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function formatDateToDMonYear(date){
    return moment(date).format("DD MMM, YYYY")
}


// WEBPACK FOOTER //
// ./src/utils/helper-functions.js